function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import analytics from '@paperstac/firebase/lib/analytics';
import auth from '@paperstac/firebase/lib/auth';
import { identityByIdRef } from '@paperstac/firestore-collections/lib/identities';
import createPersistedState from '@paperstac/hooks/lib/createPersistedState';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { flushSession, setSessionToken } from '../services/session';
import { getStateStorageAdapter, setPersistenceType } from '../services/statePersistence';
var useAuthState = createPersistedState('IdentityProviderAuthState', getStateStorageAdapter());
var useIdentityState = createPersistedState('IdentityProviderIdentityState', getStateStorageAdapter());
var IdentityContext = /*#__PURE__*/React.createContext();
var Provider = IdentityContext.Provider;
var DEFAULT_STATE = {
  claims: {},
  uid: null,
  identity: null,
  lastUpdated: null
};
var IdentityProvider = /*#__PURE__*/React.memo(function (_ref) {
  var onChange = _ref.onChange,
    children = _ref.children;
  var _useAuthState = useAuthState({
      claims: DEFAULT_STATE.claims,
      uid: DEFAULT_STATE.uid
    }),
    _useAuthState2 = _slicedToArray(_useAuthState, 2),
    authState = _useAuthState2[0],
    setAuthState = _useAuthState2[1];
  var _useIdentityState = useIdentityState({
      identity: DEFAULT_STATE.identity
    }),
    _useIdentityState2 = _slicedToArray(_useIdentityState, 2),
    identityState = _useIdentityState2[0],
    setIdentityState = _useIdentityState2[1];
  var state = React.useMemo(function () {
    return {
      claims: authState.claims,
      uid: authState.uid,
      identity: identityState.identity,
      lastUpdated: new Date().toISOString(),
      setPersistenceType: setPersistenceType
    };
  }, [authState.claims, authState.uid, identityState.identity]);
  React.useEffect(function () {
    return auth.onAuthStateChanged( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
        var idTokenResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!user) {
                  _context.next = 9;
                  break;
                }
                _context.next = 3;
                return user.getIdTokenResult();
              case 3:
                idTokenResult = _context.sent;
                setSessionToken(idTokenResult.token);
                setAuthState({
                  claims: idTokenResult.claims,
                  uid: user.uid
                });
                analytics.setUserId(user.uid);
                _context.next = 11;
                break;
              case 9:
                flushSession();
                setAuthState({
                  claims: DEFAULT_STATE.claims,
                  uid: DEFAULT_STATE.uid
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }, [setAuthState]);
  React.useEffect(function () {
    if (!authState.uid) {
      setIdentityState({
        identity: DEFAULT_STATE.identity
      });
      return;
    }
    return identityByIdRef(authState.uid).onSnapshot(function (docSnap) {
      return docSnap.exists ? setIdentityState({
        identity: docSnap.data()
      }) : setIdentityState({
        identity: DEFAULT_STATE.identity
      });
    }, function (error) {
      console.log("[IdentityProvider] Error when fetching Identity: ".concat(error.message));
    });
  }, [setIdentityState, authState.uid]);
  React.useEffect(function () {
    !!onChange && onChange(state);
  }, [onChange, state.lastUpdated]);
  React.useEffect(function () {
    analytics.setUserId(get(authState, 'uid', null));
    analytics.setUserProperties({
      campaign_id: get(identityState.identity, 'campaignId', null)
    });
  }, [authState.uid, identityState.identity]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: state
  }, children);
});
IdentityProvider.propTypes = {
  children: PropTypes.element.isRequired,
  onChange: PropTypes.func
};
export default IdentityProvider;
var withIdentity = function withIdentity(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(IdentityContext.Consumer, {
      children: function children(contexts) {
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, contexts));
      }
    });
  };
};
export { IdentityContext, withIdentity };